import { render, staticRenderFns } from "./PaymentComposition.vue?vue&type=template&id=26f90b02&"
import script from "./PaymentComposition.vue?vue&type=script&lang=js&"
export * from "./PaymentComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports